import { useMutation } from "react-query";
import {
  postData,
  postDataWithDotNet,
} from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { appInsights } from "../../../../config/appInsights";
import { message } from "antd";
import { errorHandler } from "../../../../helpers/errorHandler";
import { IResponse } from "../../../../interfaces/response";

export type TUnlockApprovalPayload = {
  transactionReferenceNumber: string;
  approvalComment: string;
  ssoUserId: string;
};

const approveAdminUnlock = async (
  payload: TUnlockApprovalPayload,
): Promise<IResponse<any>> => {
  const { data } = await postData(ajaxEndpoints.APPROVE_ADMIN_UNLOCK, payload);

  return data;
};

export function useApproveAdminUnlock() {
  const [mutate, result] = useMutation(
    (payload: TUnlockApprovalPayload) => approveAdminUnlock(payload),
    {
      onSuccess: (data) => {
        message.success(data?.message || "User unlock approved successfully.");
      },
      onError: (error) => {
        appInsights.trackException({
          exception: error,
          properties: { fileName: "useApproveAdminUnlock.ts" },
        });
        message.error(errorHandler(error));
      },
    },
  );

  return { mutate, result };
}
